"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapElementName = void 0;
function mapElementName(event) {
    if (event == null) {
        return '';
    }
    if (event.target == null) {
        return '';
    }
    var element = event.target;
    var type = element.getAttribute('type');
    return type === 'checkbox' || type === 'radio'
        ? 'select'
        : element.tagName.toLowerCase();
}
exports.mapElementName = mapElementName;
